import * as React from 'react'

export default function RegistrationLayout({
  children
}: {
  children: React.ReactNode
}) {
  return (
    <div
      style={{
        backgroundColor: 'lightgray',
        height: '100vh'
      }}
    >
      <div
        style={{
          maxWidth: 720,
          margin: 'auto'
        }}
      >
        {children}
      </div>
    </div>
  )
}
